import * as zod from 'zod';

export const DevTokensData = zod.object({
  id: zod.string(),
  token: zod.string(),
});

export type DevTokensData = zod.infer<typeof DevTokensData>;
